import * as Yup from "yup";

const RecoveryPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("required"),
});

export default RecoveryPasswordSchema;
